const DEFAULT_BUTTONS = [
  'paragraph',
  'bold',
  'italic',
  'underline',
  'strikethrough',
  '|',
  'align',
  '|',
  'ul',
  'ol',
  '|',
  'image',
  'table',
  '|',
  'source',
  '|',
  'undo',
  'redo',
  '|',
  'fullsize',
]

// Perfil de sanitização do JoditEditor.Preview para parecer e motivo da reprovação (mesmo do backend).
const RICH_TEXT_SANITIZE_PROFILE = 'richText'

const jodit = {
  DEFAULT_BUTTONS,
  RICH_TEXT_SANITIZE_PROFILE,
}

export default jodit
